import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import ImageCarousel from '../../components/ImageCarousal'

const BASE_WIKI_URL = "https://wiki.stemx365.org";
const BANNER_IMAGE = "https://wiki.stemx365.org/images/banner.jpg"; // Change this to your banner image URL


const imagesData = {
  
  KRPC: [
    "https://jaxa.krpc.jp/static/11b7ac71fb4a6a1c888db4da0c463a06/6_03.jpg",
    "/static/img/krpc/enigma-system.jpg",
    "/static/img/krpc/enigma-system-2.jpg",
    "/static/img/krpc/team_paragon.jpg",
    "/static/img/krpc/team_mukul.jpg",
    "https://jaxa.krpc.jp/static/ed2fd2f264779b67208cf1c316cad28b/6_05.jpg",
    "/static/img/krpc/team_cortex.jpg",
  ],
  AHiS: [
    "/static/img/ahis/Ahis-1.jpg",
    "/static/img/ahis/Ahis-2.jpg",
    "/static/img/ahis/Ahis-3.jpg",
    "/static/img/ahis/Ahis-4.jpg",
  ],
  ATZG: [
    "/static/img/atzg/atzg-1.png",
    "/static/img/atzg/atzg-2.png",
    "/static/img/atzg/atzg-3.png",
    "/static/img/atzg/atzg-4.png",
  ],
};

const API_URL = "/fetch_wiki";
//const API_KEY = process.env.REACT_APP_API_KEY; 
const API_KEY = "9f3c2b4e7d6a8c9e1b2f3a4d5e6b7c8d9e0f1a2b3c4d5e6f7a8b9c0d1e2f3a4b";

const MediaWikiComp = () => {
  const { pageTitle } = useParams(); // Get page name from URL
  const [content, setContent] = useState("");
  const navigate = useNavigate();

  console.log("pageTitle::::::::", pageTitle.toUpperCase());

  //const images = imagesData[pageTitle] || []; // Fallback to an empty array if type is not found
  // Convert pageTitle to uppercase for case-insensitive comparison
  const pageKey = Object.keys(imagesData).find(key => pageTitle.toUpperCase().includes(key.toUpperCase()));
  const images = pageKey ? imagesData[pageKey] : [];

  useEffect(() => {
    const fetchPageContent = async () => {
      try {
        const response = await fetch(API_URL + "?pageTitle="+pageTitle.toUpperCase(), {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": API_KEY, // Securely retrieve API key from env
          },
        });

        if (!response.ok) throw new Error("Failed to fetch");

        const data = await response.json();
        //console.log("DATA>>>>>>>>>", data);
        if (data.parse) {
          let htmlContent = data.parse.text["*"];
           // Replace all "/images/" in the page content (in the anchor and img tags)
          htmlContent = htmlContent.replace(/\/images\//g, "https://wiki.stemx365.org/images/");
          htmlContent = htmlContent.replace(/\/index.php\/File:/g, "https://wiki.stemx365.org/index.php/File:");

          // Parse and modify the content
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlContent, "text/html");

          // Remove "Contents" section (Table of Contents)
          const toc = doc.getElementById("toc");
          if (toc) toc.remove();

          // Remove all [edit] links
          doc.querySelectorAll(".mw-editsection").forEach((el) => el.remove());

          // Modify internal links but keep <img> src untouched
          doc.querySelectorAll("a").forEach((anchor) => {
            const href = anchor.getAttribute("href");

            if (href) {
              //console.log("page====");
              if (href.startsWith("/index.php/")) {
                anchor.setAttribute("href", href.replace("/index.php/", "/rect/mwiki/"));
              } else if (
                href.startsWith("/images/") ||
                href.includes("index.php/File:")
              ) {
                // Ensure images and file links have full URL
                //anchor.href = `${BASE_WIKI_URL}${href}`;
                //anchor.target = "_blank"; // Open in new tab
              }
            }
          });

          // Fix image URLs that start with /images/
          doc.querySelectorAll("img").forEach((img) => {
            const src = img.getAttribute("src");
            const srcset = img.getAttribute("srcset");
            if (src && src.startsWith("/images/")) {
              img.setAttribute("src", `https://wiki.stemx365.org${src}`);
              img.setAttribute("srcset", `https://wiki.stemx365.org${srcset}`);
            }
          });


          setContent(doc.body.innerHTML);
        }
      } catch (error) {
        console.error("Error fetching MediaWiki page:", error);
      }
    };

    fetchPageContent();
  }, [pageTitle, navigate]); // Re-fetch when pageTitle changes

  return (
    <div className="min-vh-100">
      {/* <div className="banner-container">
        <img src={BANNER_IMAGE} alt="Wiki Banner" className="banner-image" />
      </div> */}
      <ImageCarousel images={images}/>
    <div className="container mt-4">
      {/* <h2 className="text-center mb-3">{pageTitle.replace(/_/g, " ")}</h2>
       */}
          <div
            className="wiki-content bg-dark text-light p-3"
            dangerouslySetInnerHTML={{ __html: content }}
          />
       
    </div>
    </div>
  );
};

export default MediaWikiComp;
